import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

type BrowserCompatDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onRetry: () => void;
  retrying: boolean;
};

/**
 * Modal genérica de compatibilidade do navegador. Disparada no clique do
 * "Entrar" quando o ambiente do navegador impede o funcionamento do sistema
 * (ex.: extensão de bloqueio). A cópia é deliberadamente genérica — não cita
 * verificação de dispositivo / identificação.
 */
export function BrowserCompatDialog({
  open,
  onOpenChange,
  onRetry,
  retrying,
}: BrowserCompatDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Compatibilidade do navegador</DialogTitle>
          <DialogDescription>
            Identificamos uma configuração do seu navegador que pode afetar o
            funcionamento do sistema. Recomendamos usar o Google Chrome ou
            liberar <strong>thevioux.com</strong> nas extensões do navegador e
            tentar novamente.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            type="button"
            onClick={() => onOpenChange(false)}
          >
            Fechar
          </Button>
          <Button type="button" onClick={onRetry} disabled={retrying}>
            {retrying ? "Verificando..." : "Tentar novamente"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
